import moment from 'moment';

export const dateComparator = prop => {
  return (a,b) => {
    if (!b[prop] || moment.parseZone(a[prop]).isBefore(moment.parseZone(b[prop])))
      return -1;
    if (!a[prop] || moment.parseZone(a[prop]).isAfter(moment.parseZone(b[prop])))
      return 1;
    return 0;
  };
};



// WEBPACK FOOTER //
// ./src/features/shared/util/dateComparator.js